"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeCustomerNodeEdgeMapper = exports.generateGroupContainedItemToGroupsObjects = exports.generateDefaultGroupForCustomer = void 0;
const core_services_1 = require("@iotv/core-services");
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const EdgeTypeMatrix_1 = require("../classDependentTypes/EdgeTypes/EdgeTypeMatrix");
const classDependentTypes_1 = require("../classDependentTypes");
const debug_1 = require("../util/lambda/debug");
const debug = debug_1.DEBUG_OVERRIDE || (debug_1.NOT_LAMBDA && false);
const generateDefaultGroupForCustomer = (customer, groupType, includeCustomerName) => {
    const defaultName = `Default ${groupType}`;
    const name = includeCustomerName ? `${customer.name} ${defaultName}` : defaultName;
    const group = (0, core_services_1.getNamedRelatedInstance)({ type: 'Group', name: defaultName, parentUuid: customer.id, others: { supportedType: groupType } });
    /** use extended name to avoid confusion over mutiple groups with same name */
    group.name = name;
    const customerToGroupEdge = (0, iotv_v3_types_1.getZombieEdge)(customer, group, EdgeTypeMatrix_1.edgeTypeMatrix.Customer.Group.customer_has_group.edgeTypeId);
    return [customerToGroupEdge, group];
};
exports.generateDefaultGroupForCustomer = generateDefaultGroupForCustomer;
/**
 * Generate an edge between an item and group, where the group is the parent
 * @param item entity
 * @param group group that supports entity type
 * @returns
 */
const generateGroupContainedItemToGroupsObjects = (item, group) => {
    const res = [];
    if (item.type === group.supportedType) {
        const edge = (0, iotv_v3_types_1.getZombieEdge)(group, item, (0, classDependentTypes_1.getChildEdgeTypeId)('Group', item.type));
        res.push(item, edge);
    }
    return res;
};
exports.generateGroupContainedItemToGroupsObjects = generateGroupContainedItemToGroupsObjects;
/** utility used in context construction ( eg TestData ) taking a nodeEdgeMapper with a single customer and mulitple groupableItems, returning a structure with a group for each type, with edge to customer and containing groupableTypes
 * potentially this can be used as part of an iteration on multiple customer nodeEdgeMapper using extractSingleNodeEdgeMapper
 *
 * groupTypes should have enitity types added from classDerivedDeviceEnabledTypes ( @iotv/datamodel ) in concrete usages
 */
const normalizeCustomerNodeEdgeMapper = (nem, groupTypes = ['Customer', 'Device', 'Gateway', 'User']) => {
    const customers = nem.getNodesOfType('Customer');
    if (customers.length === 1) {
        customers.forEach((customer) => {
            groupTypes.forEach((groupType) => {
                let targetGroup = undefined;
                const instancesOfGroupType = nem.getNodesOfType(groupType).filter((item) => item.sk !== customer.sk);
                if (instancesOfGroupType.length > 0) {
                    const existingCustomerGroups = nem.getAdjacentNodes(customer, {
                        objectTypeId: 'Group',
                        adjacencyType: iotv_v3_types_1.AdjacentType.CHILD,
                        edgeTypeId: (0, classDependentTypes_1.getChildEdgeTypeId)('Group', groupType),
                        nodeFilters: [{ setOperation: iotv_v3_types_1.LogicalOperatorType.AND, filters: [{ key: 'supportedType', predicate: iotv_v3_types_1.ComparisonType.EQUALS, value: groupType }] }],
                    });
                    if (existingCustomerGroups.length === 0) {
                        const loadableItems = (0, exports.generateDefaultGroupForCustomer)(customer, groupType, true);
                        targetGroup = loadableItems.find(iotv_v3_types_1.isNode);
                        nem.loadItems(loadableItems);
                    }
                    else if (existingCustomerGroups.length === 1) {
                        targetGroup = existingCustomerGroups.at(0);
                    }
                    if (targetGroup) {
                        instancesOfGroupType.forEach((item) => {
                            const loadableItems = (0, exports.generateGroupContainedItemToGroupsObjects)(item, targetGroup); // The assertion is not needed under typescript 5.4
                            nem.loadItems(loadableItems);
                        });
                    }
                }
            });
        });
    }
    else {
        debug && console.log(`Not operating as customers length is ${customers.length}`);
    }
    return nem;
};
exports.normalizeCustomerNodeEdgeMapper = normalizeCustomerNodeEdgeMapper;
